import { IWindowZendesk } from "@/core/plugins/zendesk/useZendesk";

export default function useCentralDeAjudaCielo() {
  const windowZendesk = window as unknown as IWindowZendesk;

  const handleOpenCentral = async (item: { name: string }) => {
    const webWidget = document.querySelector("#webWidget");

    const estiloChat =
      "color-scheme: light;width: 374px;max-height: calc(-32px + 100vh);height: 572px;position: fixed;opacity: 1;border: 0px;transition-duration: 250ms;transition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);transition-property: opacity, top, bottom;z-index: 1040;left: 230px;bottom: 65px;box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 0.428571rem 0px;border-radius: 0.571429rem;";

    if (item.name === "Fale conosco") {
      if (webWidget) {
        windowZendesk.zE("messenger", "hide");
      } else {
        if (!windowZendesk.F360ZendeskMessagingAuth) {
          return;
        }

        try {
          await windowZendesk.F360ZendeskMessagingAuth.ensureAuthenticationAttempt();
        } catch (error) {
          if (
            error &&
            (error as { name?: string }).name !== "ZendeskConfigError"
          ) {
            console.error(error);
          }

          return;
        }

        windowZendesk.zE("messenger", "show");
        windowZendesk.zE("messenger", "open");

        windowZendesk.zE("messenger:on", "close", () => {
          windowZendesk.zE("messenger", "hide");
        });

        setTimeout(() => {
          const meuWebWidget = document.getElementById("webWidget");
          if (meuWebWidget) {
            meuWebWidget.style.cssText = estiloChat;
          }
        }, 50);
      }
    }

    const financasAside = document.querySelector(".financas-aside");

    if (financasAside) {
      financasAside.classList.remove("cielo-menu-open");
    }
  };

  return { handleOpenCentral };
}
